export const CLOCKIFY_TIMESHEETS_FETCH_MANY_REQUEST = 'CLOCKIFY_TIMESHEETS_FETCH_MANY_REQUEST'
export const CLOCKIFY_TIMESHEETS_FETCH_MANY_SUCCESS = 'CLOCKIFY_TIMESHEETS_FETCH_MANY_SUCCESS'
export const CLOCKIFY_TIMESHEETS_FETCH_MANY_FAILURE = 'CLOCKIFY_TIMESHEETS_FETCH_MANY_FAILURE'

export const EMPTY_CLOCKIFY_TIMESHEETS = 'EMPTY_CLOCKIFY_TIMESHEETS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
